export default __webpack_public_path__ + "static/media/onboard_new_plant.ea136642.svg";